export enum SecaoFormulaCustoVendaEnum {
  PrecoCusto = 1,
  PrecoVenda = 2,
}
